export const loadingText = "Loading, please wait..."